import styled from 'styled-components'
import { respondTo } from '../../styles/_respondTo'

export const InfoAboutContainer = styled.div`
  width: auto;
  height: 85vh;
  display: grid;
  grid-template-columns: 1fr 1fr;
  justify-content: center;
  gap: 10px;


  ${respondTo.xs`

  `}

  ${respondTo.sm`
  `}

  ${respondTo.md`
  `}

  ${respondTo.lg`
  grid-template-rows: 1fr 2fr;
  border-bottom: 1px solid rgb(92, 96, 105);
  margin-bottom: 20px;
  `}

  ${respondTo.xl`
  `}


`

export const ImageMe = styled.img`
  width: 50%;
  height: 250px;
  border-radius: 6px;
  box-shadow: 
    0 4px 8px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.19);

  ${respondTo.xs`
    width: 30%;
  `}

  ${respondTo.sm`
  width: 250px;
  height: 350px;
  `}

  ${respondTo.md`
  width: 280px;
  height: 350px;
  `}

  ${respondTo.lg`
    width: 280px;
    height: 350px;
  `}

  ${respondTo.xl`
    width: 280px;
    height: 350px;

  `}
`

export const ImageContainer = styled.div`
  grid-column: 1 / 3;
  display: flex;
  justify-content: center;

  ${respondTo.xs`

  `}

  ${respondTo.sm`
  `}

  ${respondTo.md`
  `}

  ${respondTo.lg`
  grid-column: 2 / 3;
  grid-row: 1/3;
  margin-top: 150px;
  `}

  ${respondTo.xl`
    grid-column: 2 / 3;

  `}
`

export const InfoContainer = styled.div`
  grid-column: 1 / 3;
  display: grid;
  justify-items: center;
  padding: 10px;
  border-bottom: 1px solid rgb(92, 96, 105);
  align-items: center;

  ${respondTo.xs`

  `}

  ${respondTo.sm`
  `}

  ${respondTo.md`
  `}

  ${respondTo.lg`
    grid-column: 1/2;
    grid-row: 1/3;
    border: none;

  `}

  ${respondTo.xl`
    grid-column: 1 / 2;
    border: none;
  `}
`

export const MeProfession = styled.h3`
  color: #707070;
  font-size: 2.2rem;
  margin: 0;
`

export const Title = styled.h5`
  color: #ffffff;
  margin: 20px 0;
  font-size: 2rem;
`

export const Info = styled.p`
  color: rgb(224, 228, 228);
  font-size: 1.5rem;
  font-family: 'IBM Plex Mono', monospace;
`

export const FlexContainer = styled.div`
  align-self: flex-start;
  grid-row: 1/2;

  ${respondTo.xs`

  `}

  ${respondTo.sm`
  `}

  ${respondTo.md`
  `}

  ${respondTo.lg`

  align-self: flex-end;
  padding-bottom: 20px;
  `}

  ${respondTo.xl`
  align-self: flex-end;
  `}


`